const toNumber = (value) => {
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const formatOrderAmount = (amount) => {
  return toNumber(amount).toFixed(2);
};

export const calculateCartSubTotal = (uniqueItems = [], getCustomizationTotal) => {
  const total = uniqueItems.reduce((subtotal, item) => {
    const lineTotal = toNumber(item?.sellingPrice) * toNumber(item?.count);
    const customizationTotal = getCustomizationTotal
      ? getCustomizationTotal(item?._id)
      : 0;

    return subtotal + lineTotal + customizationTotal;
  }, 0);

  return toNumber(total.toFixed(2));
};

export const calculateCartCostPrice = (
  uniqueItems = [],
  customizeCostPrice = 0
) => {
  const itemsCost = uniqueItems.reduce((costPrice, item) => {
    return costPrice + toNumber(item?.costPrice) * toNumber(item?.count);
  }, 0);

  return toNumber((itemsCost + toNumber(customizeCostPrice)).toFixed(2));
};

export const calculatePayableAmount = (subTotal, allChargesData = []) => {
  const baseSubTotal = toNumber(subTotal);
  let fixedChargesTotal = 0;
  let adjustedSubTotal = baseSubTotal;

  allChargesData?.forEach((charge) => {
    const chargeValue = toNumber(charge?.value);

    if (charge?.chargeType === "percentage") {
      const percentageAmount = (baseSubTotal * chargeValue) / 100;
      adjustedSubTotal += charge?.add ? percentageAmount : -percentageAmount;
      return;
    }

    fixedChargesTotal += charge?.add ? chargeValue : -chargeValue;
  });

  return toNumber((adjustedSubTotal + fixedChargesTotal).toFixed(2));
};

export const mapChargesForPayload = (allChargesData = []) => {
  return allChargesData.map((data) => ({
    chargeId: data?._id,
    amount: toNumber(data?.value),
  }));
};
